/* 馬超傳・第 6 章：成都・城中震怖（建安十九年，214）
 * 史實：〈馬超傳〉「先主遣人迎超，超將兵徑到城下。城中震怖，璋即稽首。」
 *       裴注引《典略》：劉備聽說馬超來了，「喜曰：『我得益州矣。』」；「超至未一旬而成都潰」。
 *       結局：〈馬超傳〉臨終上疏「臣門宗二百餘口，為孟德所誅略盡，惟有從弟岱，當為微宗血食之繼」；「岱位至平北將軍，進爵陳倉侯」。
 * 流程：不打仗的一章。帶兵從北邊走到成都城下：城中望見馬超的旗號，恐慌就往上漲；
 *       在城外幾處列陣（站定讀條），換個地方再列，看起來兵就更多。城裡的將領會出城試探：
 *       不理他們、讓他們看清楚軍容，回城後更怕；動手就算開戰（城中反而定下心來）。恐慌滿了，劉璋開城投降。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, vanish } from '../kit.ts';
import { band, bar, YI } from './machao_kit.ts';
import { CITY, GATE, START, SPOTS } from '../maps/machao_chengdu.ts';

const LV = 15, XUN = 120, LIMIT = 240, PROBE = 26;
const PB = { spec: YI, name: '益州兵', hp: 420, maxHp: 420, atk: 18 };

export default {
  id: 'machao-6', map: 'machao_chengdu', hero: 'machao',
  title: '第 6 章　成都・城中震怖', year: '建安十九年（214）',
  gold: 0, // 不打仗：不給軍資
  brief: {
    quote: [{ text: '先主遣人迎超，超將兵徑到城下。城中震怖，璋即稽首。', src: '《三國志·蜀書·馬超傳》' }],
    text: '馬超投奔張魯，不得志。劉備圍劉璋於成都，馬超從武都逃入氐中，寫信請降。劉備派人迎接，暗中撥兵給他，讓他帶兵直到成都城下。',
    goals: ['帶兵到成都城下', '在城外幾處列陣，讓城中恐慌', '城裡出來試探的人：不要動手'],
  },
  words: { ally: '西涼騎', foe: '益州兵' },
  stars: [
    { text: '一旬之內（120 秒）城破', ok: (m) => m.vars.fallT != null && m.vars.fallT <= XUN },
    { text: '如史：沒有開戰', ok: (m) => !m.vars.fought },
    { text: '兵卒沒有損失', ok: (m) => m.stats.lost === 0 },
  ],
  steps: [
    { // 0. 徑到城下
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1] + 100;
        V.t0 = w.t; V.panic = 0; V.probeT = 30; V.probes = []; V.spots = SPOTS.map(([x, y, name]) => ({ x, y, name, n: 0, cd: 0 }));
        V.men = band(m, me, 14, '西涼騎', { hp: 640, atk: 26 });
        m.gate('gate', GATE[0], GATE[1], 190, 'citygate');
        m.card('備聞超至，喜曰：「我得益州矣。」', '《典略》（〈馬超傳〉裴注）');
        m.after(3, () => m.line('馬超', '劉璋已經被圍了幾個月。不必攻城——讓他看看西涼的兵。'));
        m.after(7, () => m.line('提示', '靠近城下恐慌就會漲。到地圖上標的幾處列陣（站定不動），換個地方再列更有用。城裡出來試探的人別去打。'));
        V.spots.forEach((s, k) => m.mark('s' + k, s.x, s.y, s.name, true));
        m.mark('city', GATE[0], GATE[1], '成都');
        m.obj('panic', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, t = w.t - V.t0, left = LIMIT - t;
        // 望見旗號：靠近城下，恐慌慢慢漲
        if (me.alive && SG.gd(me.x, me.y, GATE[0], GATE[1]) < 1500) V.panic += dt * 0.22;
        // 列陣：每一處冷卻 12 秒；換到和上一次不同的地方效果大
        for (const [k, s] of V.spots.entries()) {
          if (s.cd > 0) { s.cd -= dt; continue; }
          if (me.chan) continue;
          m.chanAt(me, 's' + k, s.x, s.y, 230, 2.5, '列陣', () => {
            const fresh = V.last !== k, men = m.alive(V.men).filter((u) => SG.gd(u.x, u.y, s.x, s.y) < 500).length;
            const add = Math.round((fresh ? 10 : 3) * (0.5 + men / 14));
            V.panic += add; s.n++; s.cd = 12; V.last = k; V.arrays = (V.arrays || 0) + 1;
            m.unmark('s' + k);
            w.dmgEvents.push({ x: s.x, y: s.y - 110, text: `城中恐慌 +${add}`, team: 0, src: me.id });
            if (s.n === 1) m.line('城上', `${s.name}又是西涼兵的旗號！`);
          });
        }
        // 出城試探
        if ((V.probeT -= dt) <= 0 && !V.probes.some((u) => u.alive && !u.done)) {
          V.probeT = PROBE;
          const ps = Array.from({ length: 5 }, (_, i) => { const u = m.foe('huangjin', GATE[0] - 120 + i * 60, GATE[1] - 80, PB); u.asleep = true; u.probe = true; u.born = w.t; return u; });
          V.probes.push(...ps);
          m.line('益州將', '出城看看，馬超到底帶了多少兵！');
        }
        for (const u of V.probes) {
          if (!u.alive || u.done) continue;
          if (u.asleep && u.hp < u.maxHp) { // 被打了：開戰
            if (!V.fought) { V.fought = true; m.line('益州將', '馬超動手了！守城！'); }
            V.panic = Math.max(0, V.panic - 8);
            for (const o of V.probes) if (o.alive && !o.done) o.asleep = false;
          }
          if (!u.asleep) continue;
          u.target = null; u.think = 0.5;
          const age = w.t - u.born;
          if (age < 9) u.home = [me.x + (u.x - GATE[0]) * 0.5, me.y + 280]; // 走近看
          else u.home = [GATE[0], GATE[1] + 120];
          if (age > 9 && SG.gd(u.x, u.y, GATE[0], GATE[1] + 120) < 140) { u.done = true; vanish(w, u); V.seen = (V.seen || 0) + 1; if (V.seen % 5 === 0) { V.panic += 8; m.line('城上', '探子回報：城外的兵漫山遍野！'); } }
        }
        V.panic = Math.min(100, V.panic);
        m.get('panic').text = `城中恐慌 ${Math.floor(V.panic)}%（${t < XUN ? `一旬還剩 ${Math.ceil(XUN - t)} 秒` : `${Math.max(0, Math.ceil(left))} 秒後城中定下心來`}）`;
        if (left <= 0) { m.lose('城中定下心來，劉璋堅守不降'); return false; }
        return V.panic >= 100;
      },
    },
    { // 1. 璋即稽首
      enter(m, w) {
        const V = m.vars;
        V.fallT = w.t - V.t0;
        m.done('panic'); m.unmark('city'); V.spots.forEach((s, k) => m.unmark('s' + k));
        for (const u of V.probes) if (u.alive) vanish(w, u);
        m.ungate('gate');
        m.big('城中震怖');
        m.card('城中震怖，璋即稽首。', '〈馬超傳〉');
        m.after(1, () => { V.zhang = m.folk(GATE[0], GATE[1] + 60, { name: '劉璋', still: true, near: 1, look: 2 }); });
        m.after(4, () => m.card('超至未一旬而成都潰。', '《典略》（裴注）'));
        m.after(9, () => m.card('臣門宗二百餘口，為孟德所誅略盡，惟有從弟岱，當為微宗血食之繼。', '馬超臨終上疏（〈馬超傳〉）'));
        m.after(15, () => m.card('岱位至平北將軍，進爵陳倉侯。', '〈馬超傳〉'));
        m.after(20, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) { if (!w.player.alive) m.lose('馬超陣亡'); },
  overlay(ctx, m) {
    if (m.i === 0) bar(ctx, CITY.x, CITY.y - CITY.hh - 260, m.vars.panic / 100, '#e05030', '城中恐慌');
  },
};
